export type {
	BrandCategoryPageList,
	BrandCategoryPageRow,
	BrandOption,
	CategoryOption,
	PageAction,
	PageRun,
	PageStatus,
	Result,
} from "@server/brand-category-pages";

export const storefrontUrl = (path: string) =>
	`https://www.priceonline.dk${path}`;
